const CDN_URL = 'https://go-cdn-g0b5hrfac3fqf9be.a03.azurefd.net/assets'

export const getIconUrl = (name) => {
  return `${CDN_URL}/icons/${name}.svg`
}

export const getImageUrl = (name) => {
  return `${CDN_URL}/images/${name}`
}

export const getLogoUrl = (name) => {
  return `${CDN_URL}/logos/${name}`
}

export const getSoundUrl = (name) => {
  return `${CDN_URL}/sounds/${name}.mp3`
}
